<script>
import Speakers from 'gkConUI/con-speakers'
import utils from '@/utils'
import { mapState } from 'vuex'
export default {
  components: {
    Speakers
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      config: 'config'
    })
  },
  updated () {
    utils.weixinshare({
      title: this.config.wechat_share.speakers_title,
      imgUrl: this.config.wechat_share.default_logo,
      desc: this.config.wechat_share.default_desp
    })
  },
  mounted () {
    utils.weixinshare({
      title: this.config.wechat_share.speakers_title,
      imgUrl: this.config.wechat_share.default_logo,
      desc: this.config.wechat_share.default_desp
    })
  },
  render () {
    return (<Speakers/>)
  }
}
</script>
